module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-map"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
    ref: "map",
    attrs: {
      "searchBar": true,
      "api-key": _vm.mapsAPI,
      "center": _vm.mapCenter,
      "zoom": 13,
      "mapTypeId": 'roadmap',
      "scrollwheel": false,
      "zoomControl": true,
      "mapTypeControl": true
    }
  }, [(_vm.userPosition) ? _c('google-map-marker', {
    attrs: {
      "icon": '/static/icon_user_red.png',
      "position": {
        lat: _vm.userPosition.latitude,
        lng: _vm.userPosition.longitude
      },
      "title": '',
      "label": ''
    },
    on: {
      "click": _vm.updateUserPosition
    }
  }) : _vm._e(), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('google-map-marker', {
      key: vehicle.plate,
      attrs: {
        "icon": '/static/map_pin_blue.png',
        "position": {
          lat: vehicle.position.latitude,
          lng: vehicle.position.longitude
        },
        "title": vehicle.distance + ' Km',
        "label": vehicle.model,
        "labelOrigin": [15, 30]
      },
      on: {
        "click": _vm.updateSelectedVehicle
      }
    }, [_c('vehicle', {
      attrs: {
        "item": vehicle,
        "type": 'quick-booking'
      },
      on: {
        "bookVehicle": function($event) {
          return _vm.$emit('getVehicleSelected', vehicle)
        }
      }
    })], 1)
  })], 2) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24dc9386!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/BookVehicleFromMap.vue
// module id = 2283
// module chunks = 1